<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: {
    show: Boolean,
    data: Object,
    mode: {
      type: String,
      default: "add",
    },
  },

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      isLoading: false,
      optionUser: [],
      optionArea: [],
      selected: {
        user: null,
        area: null,
      },
      form: {
        user_id: null,
        id_area: null,
      },
    };
  },

  watch: {
    modalShow(val) {
      if (val) {
        if (this.mode === "edit" && this.data) {
          this.form = {
            user_id: this.data.user_id,
            id_area: this.data.id_area,
          };
          this.selected.user = {
            user_id: this.data.user_id,
            name: this.data.name ?? "",
          };
          this.selected.area = this.data.area
            ? {
                id_area: this.data.area.id_area,
                kode_area: this.data.area.kode_area,
              }
            : this.data.id_area
            ? { id_area: this.data.id_area, kode_area: "" }
            : null;
        } else {
          this.resetForm();
        }

        this.getUser();
        this.getArea();
      } else {
        this.resetForm();
      }
    },

    "selected.user"(val) {
      this.form.user_id = val?.user_id ?? null;
    },

    "selected.area"(val) {
      this.form.id_area = val?.id_area ?? null;
    },
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },

  methods: {
    ensureOptionsSelected(list, ...items) {
      items.filter(Boolean).forEach((item) => {
        const exists = list.some((opt) => {
          if (opt.user_id !== undefined) {
            return opt.user_id === item.user_id;
          }
          return opt.id_area === item.id_area;
        });
        if (!exists) list.unshift(item);
      });
    },

    getUser(search = "", loading = () => {}) {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master/setting-user-hcbp/user-login",
        params: { search: search, per_page: 50, is_get_all: false },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionUser = res.data?.data?.data ?? [];
          this.ensureOptionsSelected(this.optionUser, this.selected.user);
          loading(false);
        })
        .catch((err) => {
          console.log("err get user:", err);
          loading(false);
        });
    },

    searchUser(search, loading) {
      loading(true);
      this.getUser(search, loading);
    },

    getArea(search = "", loading = () => {}) {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master/setting-user-hcbp/area",
        params: { search: search, is_get_all: true },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionArea = res.data?.data ?? [];
          this.ensureOptionsSelected(this.optionArea, this.selected.area);
          loading(false);
        })
        .catch((err) => {
          console.log("err get area:", err);
          loading(false);
        });
    },

    searchArea(search, loading) {
      loading(true);
      this.getArea(search, loading);
    },

    resetForm() {
      this.form = {
        user_id: null,
        id_area: null,
      };
      this.selected = {
        user: null,
        area: null,
      };
    },

    store() {
      if (this.isLoading) return;

      if (!this.form.user_id) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "User Login tidak boleh kosong.",
          showConfirmButton: true,
        });
        return;
      }

      if (!this.form.id_area) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Area tidak boleh kosong.",
          showConfirmButton: true,
        });
        return;
      }

      const payload = {
        user_id: this.form.user_id,
        id_area: this.form.id_area,
      };

      this.isLoading = true;
      axios({
        method: "post",
        url: this.BACKEND_URL_VERSION + "master/setting-user-hcbp",
        data: payload,
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text:
              res.data?.meta?.message ||
              (this.mode === "edit"
                ? "Data berhasil diperbarui"
                : "Data berhasil disimpan"),
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          });

          this.$emit("close");
          this.$emit("finish");
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text:
              err.response?.data?.data ||
              err.response?.data?.meta?.message ||
              "Terjadi kesalahan.",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }, // end of store
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="mode === 'edit' ? 'Edit Setting User HCBP' : 'Tambah Setting User HCBP'"
    size="md"
    hide-footer
  >
    <b-form @submit.prevent="store">

      <b-form-group label="User Login" class="fw-medium">
        <v-select
          :options="optionUser"
          label="name"
          :get-option-key="(option) => option.user_id"
          v-model="selected.user"
          placeholder="Cari User Login"
          :filterable="false"
          :disabled="mode === 'edit'"
          @search="searchUser"
        >
          <template #option="option">{{ option.name }}</template>
          <template #selected-option="option">{{ option.name }}</template>
          <template #no-options>Ketik untuk mencari user...</template>
        </v-select>
      </b-form-group>

      <b-form-group label="Area" class="fw-medium">
        <v-select
          :options="optionArea"
          label="kode_area"
          :get-option-key="(option) => option.id_area"
          v-model="selected.area"
          placeholder="Pilih Area"
          :filterable="false"
          @search="searchArea"
        >
          <template #option="option">{{ option.kode_area }}</template>
          <template #selected-option="option">{{ option.kode_area }}</template>
          <template #no-options>Ketik untuk mencari area...</template>
        </v-select>
      </b-form-group>

      <div class="text-end mt-3">
        <b-button variant="secondary" class="me-2" @click="$emit('close')">
          Batal
        </b-button>
        <b-button type="submit" variant="primary" :disabled="isLoading">
          <span v-if="isLoading">
            <i class="fa fa-spinner fa-spin me-1"></i> Menyimpan...
          </span>
          <span v-else>Simpan</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>